import React, { useState, useEffect, useMemo } from "react";
import { apiDeleteFrame, apiCreateFrame, apiUpdateFrame } from "../api/private";
import { apiGetFrame } from "../api/public";

const useFrameCRUD = () => {
  const [frames, setFrames] = useState([]);

  const sortFrames = useMemo(
    () => frames.sort((a, b) => a.orderSort - b.orderSort),
    [frames]
  );

  const fetchFrame = async () => {
    await apiGetFrame().then((data) => setFrames(data));
  };

  const updateFrameField = async (id, key, value) => {
    const find = frames.find(({ _id }) => id === _id);
    if (find && find[key] !== value) {
      find[key] = value;
      setFrames([...frames]);
      await apiUpdateFrame(find._id, { ...find });
    }
  };

  const fetchAddFrame = async () => {
    await apiCreateFrame();
    await fetchFrame();
  };

  const fetchDeleteFrame = async (id) => {
    await apiDeleteFrame(id);
    await fetchFrame();
  };

  useEffect(() => {
    fetchFrame().then();
  }, []);

  return [
    sortFrames,
    { fetchDeleteFrame, fetchFrame, fetchAddFrame, updateFrameField, setFrames },
  ];
};

export default useFrameCRUD;



// WEBPACK FOOTER //
// ./src/hooks/useFrameCRUD.js